<template>
  <Pill :small="small" :danger="availability === 0" :warning="availability !== -99999 && !simple && availability < 6" :success="availability > (simple ? 0 : 5) || availability === -99999" v-if="course.maxAttendeesPerSession || course.isTicketSalesEvent">
    <span v-if="availability === Infinity">{{ $t('Beschikbaar') }}</span>
    <span v-else-if="!simple && !club.disable_waiting_list">{{ $tc('course.availability', availability) }}</span>
    <span v-else-if="!simple && club.disable_waiting_list && availability > 0">{{ $tc('course.availability', availability) }}</span>
    <span v-else-if="!simple && club.disable_waiting_list && availability <= 0">Volzet</span>
    <span v-else-if="simple">{{ availability > 0 ? $t('Beschikbaar') : $t('Wachtrij') }}</span>
  </Pill>
</template>

<script>
import Pill from '../Core/Pill'
export default {
  name: 'Availability',
  components: {
    Pill
  },
  props: {
    tariff: Object,
    course: Object,
    simple: Boolean,
    small: Boolean
  },
  computed: {
    availability () {
      if (parseInt(this.course.hideVenueLayout)) {
        if (!this.tariff.maxUsers) return Infinity
      }
      return Math.max(0, this.tariff.availability)
    },
    club () {
      return this.$store.getters['club/club']
    }
  }
}
</script>
